export enum PermitType {
    hotWork = 1,
    flammableAtex = 2,
}
